import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const mapState = ({
  errors: { chat_connection: chatConnectionErrors, chat_messages: chatMessagesErrors },
}) => ({ chatConnectionErrors, chatMessagesErrors });

const useChatErrors = () => {
  const { chatConnectionErrors, chatMessagesErrors } = useSelector(mapState);
  const { t } = useTranslation();

  const connectionErrors = [];
  const messageErrors = [];

  if (chatConnectionErrors) {
    if (chatConnectionErrors.disconnected) {
      connectionErrors.push({
        kind: 'alert',
        title: t('errors.socket_connection_failed.title'),
        text: t('errors.socket_connection_failed.text'),
      });
    }
    if (chatConnectionErrors.connection) {
      connectionErrors.push({
        kind: 'warning',
        title: t('errors.socket_connection_error.title'),
        text: t('errors.socket_connection_error.text'),
      });
    }
  }

  if (chatMessagesErrors) {
    Object.keys(chatMessagesErrors).forEach(type => {
      if (type === 'load') {
        messageErrors.push({
          kind: 'alert',
          title: t('errors.loading_messages_failed.title'),
          text: t('errors.loading_messages_failed.text'),
        });
      }
      if (type === 'send') {
        messageErrors.push({
          kind: 'alert',
          title: t('errors.sending_message_failed.title'),
          text: t('errors.sending_message_failed.text'),
        });
      }
    });
  }
};

export default useChatErrors;
